import { computed } from 'vue'
import L from 'leaflet'

interface CoordinatesType {
    lat: number,
    lng: number
}

export const useBoundsCalculator = (coordinates: CoordinatesType) => {
    // Радиус Земли в километрах
    const R = 6371

    // Расстояние в километрах (10 км)
    const distance = 10

    // Конвертируем градусы в радианы
    const lat = coordinates.lat * Math.PI / 180
    const lng = coordinates.lng * Math.PI / 180

    // Вычисляем угловое расстояние в радианах
    const angular = distance / R

    // Вычисляем границы широты
    const latMin = lat - angular
    const latMax = lat + angular

    // Вычисляем границы долготы
    const lngMin = lng - angular / Math.cos(lat)
    const lngMax = lng + angular / Math.cos(lat)


    const bounds = computed(() => {
        return L.latLngBounds(
            [
                latMin * 180 / Math.PI,
                lngMin * 180 / Math.PI
            ],
            [
                latMax * 180 / Math.PI,
                lngMax * 180 / Math.PI
            ]
        )
    })

    const filterBounds = computed(() => {
        return {
            minLat: latMin * 180 / Math.PI,
            maxLat: latMax * 180 / Math.PI,
            minLng: lngMin * 180 / Math.PI,
            maxLng: lngMax * 180 / Math.PI,
        }
    })

    return {
        bounds, filterBounds
    }
}

/*
const { bounds } = useBoundsCalculator(coordinates)

        // Используйте bounds для фильтрации мастеров
        const nearbyMasters = computed(() => {
            return allMasters.value.filter(master => {
                const masterLatLng = L.latLng(master.lat, master.lng)
                return bounds.value.contains(masterLatLng)
            })
        })
        */
